import React, { useContext, useRef } from "react";
import PropTypes from "prop-types";
import { NavLink } from "react-router-dom";
import { useAuth, useAuthDispatch, resetPassword } from "../context/Auth";
import SystemContext from "../context/System";
import { AUTH_STATUS } from "../constants";

const ResetPasswordForm = (props) => {
  const { data } = props;
  const { status, error } = useAuth();
  const dispatch = useAuthDispatch();

  const { system } = useContext(SystemContext);
  const pass_ref = useRef();
  const confirm_pass_ref = useRef();

  const _handleSubmit = (e) => {
    e.preventDefault();
    const resetPassData = {
      password: pass_ref.current.value,
      confirmPassword: confirm_pass_ref.current.value,
      email: data.email,
      reset_code: data.reset_code,
    };
    resetPassword(dispatch, resetPassData);
  };

  const _handleFocus = () => {
    if (error) {
      dispatch({ error: null });
    }
  };

  const inputClassName = `form-control ${system?.identifier}-input ${
    error?.message && "is-invalid"
  }`;

  if (!system) {
    return null;
  }

  if (status === AUTH_STATUS.APPROVED) {
    return (
      <div className='text-center'>
        <p className='pb-3 mb-4'>You have successfully reset your password.</p>
        <NavLink to='/login' className={`btn ${system.identifier}-btn px-2`}>
          Return to login
        </NavLink>
      </div>
    );
  }

  return (
    <form
      className='position-relative'
      style={{ marginTop: -50 }}
      onSubmit={_handleSubmit}
      onFocus={_handleFocus}
    >
      <p className='pb-1 mb-4 text-center'>Choose your new password</p>
      <div className='form-group pb-3 mb-4'>
        <label>Password</label>
        <input
          type='password'
          name='password'
          className={inputClassName}
          title='password'
          ref={pass_ref}
        />
      </div>
      <div className='form-group'>
        <label>Confirm password</label>
        <input
          type='password'
          name='confirmPassword'
          className={inputClassName}
          title='Confirm password'
          ref={confirm_pass_ref}
        />
      </div>
      {error?.message ? (
        <p className='text-center text-danger my-2'>{error.message}</p>
      ) : (
        <p className='invisible my-2'>.</p>
      )}
      <div className='form-group text-center mb-4'>
        <button
          className={`btn ${system.identifier}-btn mb-4`}
          type='submit'
          disabled={status === AUTH_STATUS.PENDING}
        >
          {status === AUTH_STATUS.PENDING ? (
            <span
              className='spinner-border spinner-border-sm'
              role='status'
              aria-hidden='true'
            ></span>
          ) : (
            "Submit"
          )}
        </button>
        <br />
        <NavLink to='/login' className='fs-7 text-white'>
          Return to login
        </NavLink>
      </div>
    </form>
  );
};
ResetPasswordForm.propTypes = {
  data: PropTypes.objectOf(PropTypes.any).isRequired,
};
export default ResetPasswordForm;
